import { capitalize } from "../../utils/capitalize";

export function formatClientData(clientFound: any): any {
  if (clientFound.endereco_alternativo) {
    clientFound.endereco_alternativo.bairro = capitalize(
      clientFound.endereco_alternativo.bairro
        ? clientFound.endereco_alternativo.bairro
        : ""
    );
    clientFound.endereco_alternativo.localidade = capitalize(
      clientFound.endereco_alternativo.localidade
        ? clientFound.endereco_alternativo.localidade
        : ""
    );
    clientFound.endereco_alternativo.cidade = capitalize(
      clientFound.endereco_alternativo.cidade
        ? clientFound.endereco_alternativo.cidade
        : ""
    );
    clientFound.endereco_alternativo.logradouro = capitalize(
      clientFound.endereco_alternativo.logradouro
        ? clientFound.endereco_alternativo.logradouro
        : ""
    );
    clientFound.endereco_alternativo.complemento = capitalize(
      clientFound.endereco_alternativo.complemento
        ? clientFound.endereco_alternativo.complemento
        : ""
    );
  }

  if (clientFound.endereco_comercial) {
    clientFound.endereco_comercial.empresa = capitalize(
      clientFound.endereco_comercial.empresa
        ? clientFound.endereco_comercial.empresa
        : ""
    );
    clientFound.endereco_comercial.departamento = capitalize(
      clientFound.endereco_comercial.departamento
        ? clientFound.endereco_comercial.departamento
        : ""
    );
    clientFound.endereco_comercial.bairro = capitalize(
      clientFound.endereco_comercial.bairro
        ? clientFound.endereco_comercial.bairro
        : ""
    );
    clientFound.endereco_comercial.localidade = capitalize(
      clientFound.endereco_comercial.localidade
        ? clientFound.endereco_comercial.localidade
        : ""
    );
    clientFound.endereco_comercial.cidade = capitalize(
      clientFound.endereco_comercial.cidade
        ? clientFound.endereco_comercial.cidade
        : ""
    );
    clientFound.endereco_comercial.logradouro = capitalize(
      clientFound.endereco_comercial.logradouro
        ? clientFound.endereco_comercial.logradouro
        : ""
    );
    clientFound.endereco_comercial.complemento = capitalize(
      clientFound.endereco_comercial.complemento
        ? clientFound.endereco_comercial.complemento
        : ""
    );
  }
  if (clientFound.endereco_residencial) {
    clientFound.endereco_residencial.bairro = capitalize(
      clientFound.endereco_residencial.bairro
        ? clientFound.endereco_residencial.bairro
        : ""
    );
    clientFound.endereco_residencial.localidade = capitalize(
      clientFound.endereco_residencial.localidade
        ? clientFound.endereco_residencial.localidade
        : ""
    );
    clientFound.endereco_residencial.cidade = capitalize(
      clientFound.endereco_residencial.cidade
        ? clientFound.endereco_residencial.cidade
        : ""
    );
    clientFound.endereco_residencial.logradouro = capitalize(
      clientFound.endereco_residencial.logradouro
        ? clientFound.endereco_residencial.logradouro
        : ""
    );
    clientFound.endereco_residencial.complemento = capitalize(
      clientFound.endereco_residencial.complemento
        ? clientFound.endereco_residencial.complemento
        : ""
    );
  }

  return clientFound;
}
